export const fileChange = (b64String, setFile, setIsPictureTaken, handleFileUpload) => {
  // Convert b64 image to file
  const meta = b64String.split(",")[0];
  const fileType = meta.split(";")[0].split(":")[1];

  fetch(b64String)
    .then((res) => {
      res
        .blob()
        .then((blob) => {
          const newFile = new File([blob], `photo-img-web-${Date.now()}`, {
            type: fileType,
          });
          setFile(newFile);
          setIsPictureTaken(true);
          //  Upload the newly created file to Firebase Storage.
          handleFileUpload(newFile);
        })
        .catch((err) => console.log("Error getting blob", err));
    })
    .catch((err) => console.log("Error fetching b64 image", err));
};
